import BaseContactUs from './ContactUs';

export const ContactUs = BaseContactUs;
export type { ContactUsProps } from './ContactUs.interface';
